module.exports = __webpack_public_path__ + "static/1-46d53ef3b37f9e00e970f3c87c320815.png";